import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=029ad397&"
import script from "./ModalForm.vue?vue&type=script&lang=ts&"
export * from "./ModalForm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports